export default "__VITE_ASSET__DNkt_wP8__"